import React from "react";

const AircraftCellRenderer = ({ row }) => {
    const rawFlight = row.rawFlight || {};
    const registration = row.aircraftReg || rawFlight.aircraft_reg;
    const aircraftType = rawFlight.aircraft_type || rawFlight.aircraft?.aircraft_type || rawFlight.aircraft_snapshot?.aircraft_type;
    const label = registration || "未分配";
    const title = aircraftType ? `${label} / ${aircraftType}` : label;

    return (
        <span className="schedule-draft-rdg-aircraft-cell" title={title}>
            {label}
        </span>
    );
};

export default AircraftCellRenderer;
